export const HeaderSection = {
  partners: 'Партнери',
  accessories: 'Аксесуари',
  stages: 'Етапи',
  order: 'Замовлення',
};
export const description = "Розумний будинок - це ваш особистий помічник, який піклується про ваш комфорт і затишок. Система може бути встановлена в будь-якому місці, де ви живете або працюєте. Для управління нею достатньо планшета, телефону або комп'ютера. Завдяки унікальному захищеному протоколу та мобільному додатку, комплекс гарантує вам повний контроль над приміщенням у будь-який час. Для того, щоб увімкнути світло, відкрити штори або вимкнути кондиціонер - не обов'язково вставати з дивана."